import React, { useRef, useState } from "react";
import { Content, GoodsImg, Line, MLabel, Wrapper } from "./styles";
import Loading from "components/Loading";
import HeaderBox from "components/HeaderBox";
import MessageBox from "components/MessageBox";
import { Box, Button, Stack, Typography } from "@mui/material";
import DialogChangeInvGoods from "components/DialogChangeInvGoods";
import { INV_GOODS_CHANGE_MODE, INV_GOODS_CHANGE_TXT_TITLE, INV_HISTORY_ACTION_TYPE, MESSAGE } from "Common";
import { useInvGoodsDetails } from "./useInvGoodsDetails";
import InvHistoryItem from "./InvHistoryItem";
import DialogAddGoods from "components/DialogAddGoods";
import dayjs from "dayjs";
import DialogEditInvHistory from "components/DialogEditInvHistory";
import DialogEditInvGoods from "components/DialogEditInvGoods";
import ButtonBack from "components/ButtonBack";
import { TiShoppingCart, TiEdit, TiTrash } from "react-icons/ti";
import { FaBox, FaTruck } from "react-icons/fa";

const InvGoodsDetails = () => {
    const { navigate, isLoading, setIsLoading
        , setReload, message, setMessage, invGoods
        , mGoods, setMGoods
        , handleDeleteInvHistory
        , handleDeleteInvGoods
    } = useInvGoodsDetails();
    const refTop = useRef();
    const [changeInvGoodsFlg, setChangeInvGoodsFlg] = useState(INV_GOODS_CHANGE_MODE.NONE);
    const [invGoodsSelected, setInvGoodsSelected] = useState();
    const [invHistorySelected, setInvHistorySelected] = useState();
    const [invGoodsEdit, setInvGoodsEdit] = useState();




    // useEffect(() => {
    //     refTop.current.scrollTo(0, 0);
    //     return;
    // }, [siteList, refTop])

    return (
        <Wrapper>
            {!!invGoods?.ClientInventoryGoodsID && (
                <>
                    <Loading isLoading={isLoading} />
                    <HeaderBox title={"在庫詳細"} haveCart />
                    <div style={{ position: "relative" }}>
                        <Stack direction="row" sx={{ pt: 1 }}>
                            <Box sx={{ flex: 1 }}>
                                <Line style={{}}>
                                    <MLabel>商品名：</MLabel>
                                    {invGoods?.GoodsName || ''}
                                </Line>
                                <Line style={{}}>
                                    <MLabel>サイズ：</MLabel>
                                    {invGoods?.GoodsSize || ''}
                                </Line>
                                <Line>
                                    <MLabel>単位：</MLabel>
                                    {invGoods?.StockQMemo || ''}
                                </Line>
                                <Line>
                                    <MLabel>保管場所：</MLabel>
                                    {invGoods?.ShelfName || ''}
                                </Line>
                                <Line>
                                    <MLabel>在庫メモ：</MLabel>
                                    {invGoods?.ClientInventoryGoodsMemo || ''}
                                </Line>
                                <Line>
                                    <MLabel>現在在庫数：</MLabel>
                                    {(invGoods?.StockQ + (invGoods?.StockQMemo || "")) || '-'}
                                </Line>
                                <Line>
                                    <MLabel>商品画像：</MLabel>
                                </Line>
                                <Box pl={"66px"} textAlign={'center'}>
                                    {invGoods?.ImageUrl1 || invGoods?.ImageUrl2 ? <GoodsImg src={invGoods?.ImageUrl1 || invGoods?.ImageUrl2} alt="image" /> : '-'}
                                </Box>

                            </Box>
                            <Stack direction="column" spacing={1} sx={{ p: 1, alignItems: 'center' }}>
                                {invGoods?.GoodsID > 1 && (<Button variant="contained" size="small" startIcon={<TiShoppingCart />}
                                    sx={{ backgroundColor: "#009527", '&:hover': { backgroundColor: "#007a1c" } }}
                                    onClick={() => {
                                        setMGoods({
                                            GoodsID: invGoods.GoodsID, GoodsSubID: invGoods.GoodsSubID
                                            , GoodsName: invGoods.GoodsName, GoodsSize: invGoods.GoodsSize
                                            , GoodsKana: invGoods.GoodsKana
                                        });
                                    }}>注文</Button>)}
                                <Button variant="contained" size="small" sx={{ minWidth: "50px" }}
                                    startIcon={<TiEdit />}
                                    onClick={() => {
                                        setInvGoodsEdit({
                                            ClientInventoryGoodsID: invGoods.ClientInventoryGoodsID
                                            , GoodsName: invGoods.GoodsName
                                            , GoodsSize: invGoods.GoodsSize
                                            , StockQMemo: invGoods.StockQMemo
                                            , ClientInventoryGoodsMemo: invGoods.ClientInventoryGoodsMemo
                                            , ImageUrl1: invGoods.ImageUrl1
                                            , ImageUrl2: invGoods.ImageUrl2
                                        })
                                    }}>編集</Button>
                                <Button variant="contained" size="small" sx={{ minWidth: "50px" }}
                                    color="secondary" startIcon={<TiTrash />}
                                    onClick={() => { handleDeleteInvGoods(invGoods) }}>削除</Button>
                            </Stack>
                        </Stack>
                        <Stack direction="row" spacing={3} sx={{ mt: 1, justifyContent: 'center' }}>
                            <Button variant="contained" size="small"
                                startIcon={<FaBox />} sx={{ backgroundColor: "#009527", '&:hover': { backgroundColor: "#007a1c" } }}
                                onClick={() => {
                                    setChangeInvGoodsFlg(INV_GOODS_CHANGE_MODE.ADD);
                                    setInvGoodsSelected({ ...invGoods, invHistory: undefined });
                                }}>入庫</Button>
                            <Button variant="contained" size="small"
                                startIcon={<FaTruck />}
                                onClick={() => {
                                    setChangeInvGoodsFlg(INV_GOODS_CHANGE_MODE.SUB);
                                    setInvGoodsSelected({ ...invGoods, invHistory: undefined });
                                }}>出庫</Button>
                        </Stack>
                        <Stack direction="row" sx={{ mt: 1, backgroundColor: '#d3e8d8', alignItems: 'center' }}>
                            <Typography sx={{ p: 1, fontWeight: 'bold', flex: 1 }}>在庫履歴</Typography>
                        </Stack>
                        <Content ref={refTop}>
                            {
                                invGoods?.invHistory.map((item) => {
                                    return (
                                        <InvHistoryItem key={`invh_${item.ClientInventoryHistoryID}`} invHistory={item}
                                            handleDelete={() => {
                                                const msgConfirm = {
                                                    contents: [`${dayjs(item?.AddedDate).format('YYYY/MM/DD')} ${INV_HISTORY_ACTION_TYPE[item.ActionType]} 在庫数：${item.NumberQ}`
                                                        , 'この在庫履歴を削除します。よろしいですか？']
                                                    , type: MESSAGE.WARNING
                                                    , isYesNo: true
                                                    , handleYes: () => { handleDeleteInvHistory(item); }
                                                };
                                                setMessage(msgConfirm);
                                            }}
                                            handleEdit={() => { setInvHistorySelected({ ...item }); }}
                                        />
                                    );
                                })
                            }

                        </Content>
                    </div>
                    <MessageBox message={message} setMessage={setMessage} />
                    <DialogChangeInvGoods txtTitle={INV_GOODS_CHANGE_TXT_TITLE[changeInvGoodsFlg]}
                        invGoods={invGoodsSelected}
                        changeFlg={changeInvGoodsFlg}
                        handleClose={() => { setChangeInvGoodsFlg(INV_GOODS_CHANGE_MODE.NONE); setInvGoodsSelected(null) }}
                        setIsLoading={setIsLoading}
                        setReload={setReload}
                        setMessage={setMessage}

                    />
                    <DialogAddGoods goods={mGoods} handleClose={() => { setMGoods(null) }} />
                    <DialogEditInvGoods invGoods={invGoodsEdit}
                        handleClose={() => { setInvGoodsEdit(null) }}
                        setIsLoading={setIsLoading}
                        setReload={setReload}
                        setMessage={setMessage} />
                    <DialogEditInvHistory invHistory={invHistorySelected}
                        handleClose={() => { setInvHistorySelected(null) }}
                        setIsLoading={setIsLoading}
                        setReload={setReload}
                        setMessage={setMessage} />
                    <ButtonBack onHandleBack={() => { navigate(-1) }} />

                </>
            )}
        </Wrapper>
    )
}

export default InvGoodsDetails;